import {COUNTRIES_SHORT} from "./countries.config";

export const PHONE_MASK = {
    [COUNTRIES_SHORT.usa]: '(000) 000-0000',
    [COUNTRIES_SHORT.mexico]: '00 0000 0000',
    [COUNTRIES_SHORT.france]: '00 00 00 00 00'
};
